var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-authenticated',{attrs:{"show-product-type-filters":""}},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumb}}),_c('h1',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t('products.products')))]),_c('products-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }